import { everest } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { ParsedType } from '../../transformers/utils';

type Response = {
  ticket_id: Uuid;
  is_completed: boolean;
};

type Request = {
  contractRecordUniqueId?: string;
  wssContractId?: Uuid;
};

export const resolveWssTicketId = async ({
  contractRecordUniqueId,
  wssContractId,
}: Request): Promise<ParsedType<Response>> => {
  const response: Response = await everest.get(`/tickets/resolve-ticket-id/`, {
    params: {
      wss_contract_id: wssContractId,
      contract_record_unique_id: contractRecordUniqueId,
    },
  });

  return {
    ticketId: response.ticket_id,
    isCompleted: response.is_completed,
  };
};
